import { useQuery } from '@tanstack/react-query'

import { getAgenticPrompt } from 'services/agenticPrompts'

export const AGENTIC_PROMPT_QUERY_KEY = 'agenticPromptQuery'

function useAgenticPrompt(id) {
  const { isLoading, data: prompt } = useQuery(
    [AGENTIC_PROMPT_QUERY_KEY, id],
    () => getAgenticPrompt(id),
    {
      enabled: !!id,
      refetchOnWindowFocus: false,
      useErrorBoundary: true,
    },
  )

  return { prompt, isLoading }
}

export { useAgenticPrompt }
